var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "row" }, [
    _c("div", { staticClass: "col-12" }, [
      _c(
        "form",
        {
          staticClass: "forms-sample",
          on: {
            submit: function($event) {
              $event.preventDefault()
              return _vm.updateAccountData($event)
            }
          }
        },
        [
          _c(
            "div",
            { staticClass: "form-group" },
            [
              _c(
                "label",
                {
                  staticClass: "font-weight-bolder",
                  attrs: { for: "first_name" }
                },
                [_vm._v(_vm._s(_vm.$t("user.first_name")))]
              ),
              _vm._v(" "),
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.user.first_name,
                    expression: "user.first_name"
                  }
                ],
                staticClass: "form-control",
                class: { "is-invalid": _vm.$errors.has("first_name") },
                attrs: {
                  type: "text",
                  id: "first_name",
                  placeholder: _vm.$t("user.first_name")
                },
                domProps: { value: _vm.user.first_name },
                on: {
                  input: function($event) {
                    if ($event.target.composing) {
                      return
                    }
                    _vm.$set(_vm.user, "first_name", $event.target.value)
                  }
                }
              }),
              _vm._v(" "),
              _c("error", { attrs: { input: "first_name" } })
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "form-group" },
            [
              _c(
                "label",
                {
                  staticClass: "font-weight-bolder",
                  attrs: { for: "last_name" }
                },
                [_vm._v(_vm._s(_vm.$t("user.last_name")))]
              ),
              _vm._v(" "),
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.user.last_name,
                    expression: "user.last_name"
                  }
                ],
                staticClass: "form-control",
                class: { "is-invalid": _vm.$errors.has("last_name") },
                attrs: {
                  type: "text",
                  id: "last_name",
                  placeholder: _vm.$t("user.last_name")
                },
                domProps: { value: _vm.user.last_name },
                on: {
                  input: function($event) {
                    if ($event.target.composing) {
                      return
                    }
                    _vm.$set(_vm.user, "last_name", $event.target.value)
                  }
                }
              }),
              _vm._v(" "),
              _c("error", { attrs: { input: "last_name" } })
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "form-group" },
            [
              _c(
                "label",
                { staticClass: "font-weight-bolder", attrs: { for: "email" } },
                [_vm._v(_vm._s(_vm.$t("user.email")))]
              ),
              _vm._v(" "),
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.user.email,
                    expression: "user.email"
                  }
                ],
                staticClass: "form-control",
                class: { "is-invalid": _vm.$errors.has("email") },
                attrs: {
                  type: "email",
                  id: "email",
                  placeholder: _vm.$t("user.email")
                },
                domProps: { value: _vm.user.email },
                on: {
                  input: function($event) {
                    if ($event.target.composing) {
                      return
                    }
                    _vm.$set(_vm.user, "email", $event.target.value)
                  }
                }
              }),
              _vm._v(" "),
              _c("error", { attrs: { input: "email" } })
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "form-group" },
            [
              _c(
                "label",
                {
                  staticClass: "font-weight-bolder",
                  attrs: { for: "preferred_language" }
                },
                [_vm._v(_vm._s(_vm.$t("user.preferred_language")))]
              ),
              _vm._v(" "),
              _c(
                "select",
                {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.user.preferred_language,
                      expression: "user.preferred_language"
                    }
                  ],
                  staticClass: "form-control",
                  class: {
                    "is-invalid": _vm.$errors.has("preferred_language")
                  },
                  attrs: {
                    id: "preferred_language",
                    placeholder: _vm.$t("user.preferred_language")
                  },
                  on: {
                    change: function($event) {
                      var $$selectedVal = Array.prototype.filter
                        .call($event.target.options, function(o) {
                          return o.selected
                        })
                        .map(function(o) {
                          var val = "_value" in o ? o._value : o.value
                          return val
                        })
                      _vm.$set(
                        _vm.user,
                        "preferred_language",
                        $event.target.multiple
                          ? $$selectedVal
                          : $$selectedVal[0]
                      )
                    }
                  }
                },
                [
                  _c("option", { attrs: { value: "lb" } }, [
                    _vm._v(
                      "\n                        " +
                        _vm._s(_vm.$t("languages.luxembourgish")) +
                        "\n                    "
                    )
                  ]),
                  _vm._v(" "),
                  _c("option", { attrs: { value: "en" } }, [
                    _vm._v(
                      "\n                        " +
                        _vm._s(_vm.$t("languages.english")) +
                        "\n                    "
                    )
                  ]),
                  _vm._v(" "),
                  _c("option", { attrs: { value: "de" } }, [
                    _vm._v(
                      "\n                        " +
                        _vm._s(_vm.$t("languages.german")) +
                        "\n                    "
                    )
                  ])
                ]
              ),
              _vm._v(" "),
              _c("error", { attrs: { input: "preferred_language" } })
            ],
            1
          ),
          _vm._v(" "),
          _c("div", { staticClass: "form-group" }, [
            _c("button", { staticClass: "btn btn-outline-dark" }, [
              _vm._v(
                "\n                    " +
                  _vm._s(_vm.$t("actions.save")) +
                  "\n                "
              )
            ])
          ])
        ]
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }